import {useCallback, useEffect, useState} from 'react';
import {Loading} from 'acud';
import BaiduLogo from '@/assets/baidusquare.svg?react';

export default function PassportWrap({isWap, initFunc}: {isWap?: boolean; initFunc: () => Promise<any>}) {
    const [loading, setLoading] = useState(true);
    const init = useCallback(async () => {
        await initFunc();
        setLoading(false);
    }, [initFunc]);

    useEffect(() => {
        // http://dev.passport.baidu.com/docs/agg/viewv2?path=tech.text&doc=pc/passport/loginv4.text
        // PASSPORT SDK实例化代码后会有unicast轮训接口，若在页面渲染时就初始化会导致页面一直loading状态，可以将登录初始化逻辑放至window.onload中
        // https://www.zhangxinxu.com/wordpress/2019/10/document-readystate/
        if (document.readyState === 'complete') {
            init();
        } else {
            window.addEventListener('load', init);
        }

        return () => {
            window.removeEventListener('load', init);
        };
    }, [init]);
    return (
        <>
            {loading && (
                <div className="loading-wrap">
                    <Loading />
                </div>
            )}
            <div id="pass-login"></div>
            {isWap && (
                <>
                    <div className="separate-wrap">其他方式</div>
                    <div className="quick-login">
                        <BaiduLogo />
                        <span>百度APP一键登录</span>
                    </div>
                </>
            )}
        </>
    );
}
